<template>
	<div>
        <van-form @submit="onSubmit">
            <van-field
                    v-model="params.companyName"
                    name="发票抬头"
                    label="发票抬头"
                    :rules="[{ required: true, message: '请填写发票抬头' }]"
            />
            <van-field
                    v-model="params.tin"
                    name="纳税人识别号"
                    label="纳税人识别号"
                    :rules="[{ required: true, message: '请填写纳税人识别号' }]"
            />
            <van-field
                    v-model="params.telephone"
                    name="注册电话"
                    label="注册电话"
                    :rules="[{ required: true, message: '请填写注册电话' }]"
            />
            <van-field
                    v-model="params.bank"
                    name="开户银行"
                    label="开户银行"
                    :rules="[{ required: true, message: '请填写开户银行' }]"
            />
            <van-field
                    v-model="params.email"
                    name="电子邮箱"
                    label="电子邮箱"
                    :rules="[{ required: true, message: '请填写电子邮箱' }]"
            />
            <van-field
                    v-model="params.mobile"
                    name="收票人手机"
                    label="收票人手机"
                    :rules="[{ required: true, message: '请填写收票人手机' }]"
            />
            <div style="margin: 16px;text-align:center">
                <van-button round type="info" native-type="submit">
                    提交
                </van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import {
    Form ,
    Field,
    Button,
    Toast,
} from 'vant';
import {
    applyInvoice
} from "@/api/dictionary";
import {getSessionStore} from "@/utils/sessionStorage.js"
export default {
      props: {
    item: {
      type: Object,
      default: () => {}
    },
    
  },
  data() {
    return {
        MESSAGE:{
          CONST_MESSAGE_INVOICE_DETEMINED_SUCCESS:"开票成功."
      },
        params:{
            orderId:'',
            // 发票信息
            id:'',
            tid:'',//租户Id
            invoiceType:1,//发票类型
            titleType:1,//抬头类型
            companyName:'',//公司名称
            contentType:'',//发票内容
            amount:'',//金额
            deliveryType:3,//取票方式
            addressId:'',//地址信息
            address:'',//注册地址
            telephone:'',//注册电话
            tin:'',//纳税人识别号
            bank:'',//开户银行
            account:'',//银行账户
            // 地址信息
            province:'',//省
            city:'',//市
            contact:'',//联系人
            mobile:'',//联系电话
            detailedAddress:'',//详细地址
            zipcode:''//邮编
        }
    };
  },
  filters: {
    
  },
  components: {
    [Form.name]:Form,
    [Field.name]:Field,
    [Button.name]:Button,
    [Toast.name]:Toast,
  },
  methods: {
      onSubmit() {
          applyInvoice(this.params).then(res => {
              if (res.success) {
                  Toast.success(this.MESSAGE.CONST_MESSAGE_INVOICE_DETEMINED_SUCCESS);
                  this.clearFormParams();
                  this.b();
              } else {
                  Toast.fail(res.message);
              }
          });
      },
      b(){
        this.$emit("b");
      },
      clearFormParams:function(){
          this.dialogInvoiceForm={
              orderId:'',
              // 发票信息
              id:'',
              tid:'',//租户Id
              invoiceType:1,//发票类型
              titleType:1,//抬头类型
              companyName:'',//公司名称
              contentType:'',//发票内容
              amount:'',//金额
              deliveryType:3,//取票方式
              addressId:'',//地址信息
              address:'',//注册地址
              telephone:'',//注册电话
              tin:'',//纳税人识别号
              bank:'',//开户银行
              account:'',//银行账户
              // 地址信息
              province:'',//省
              city:'',//市
              contact:'',//联系人
              mobile:'',//联系电话
              detailedAddress:'',//详细地址
              zipcode:''//邮编
          };
      },
  },
  computed: {
    
  },
  watch:{
	
  },
  mounted() {
    //   let invoice = eval('('+getSessionStore("invoice")+')');
      this.params.amount=this.item.amount;
      this.params.orderId=this.item.id;
  }

}
</script>